import React from 'react';
import { style_font_small } from '../../constants/styles';
import EventIconWrapper from '../EventIconWrapper';
import { EventIconProps } from './EventIconProps';

class YellowCardWithShirtNumber extends React.Component<EventIconProps> {
  render(): JSX.Element {
    let { shirtNumber } = this.props;
    if (shirtNumber.length === 1) {
      shirtNumber = '0' + shirtNumber;
    }
    return (
      <EventIconWrapper>
        <circle cx="14.1993" cy="14.0989" r="13.3408" fill="#F9F9F9" stroke="#DCDCDC" />
        <text style={style_font_small}>
          <tspan x="9.5" y="24.5508">
            {shirtNumber}
          </tspan>
        </text>
        <path
          d="M12.1984 17.4904L13.4224 15.8563C13.519 15.7274 13.4853 15.539 13.3472 15.4356L9.84556 12.8127C9.70743 12.7092 9.51716 12.7299 9.42059 12.8588L8.19658 14.4929"
          stroke="#323232"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: '#FFFFFF' }}
        />
        <path
          d="M10.3318 13.1769C11.2936 7.20156 9.70235 8.83386 16.5701 5.39906"
          stroke="#323232"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: '#FFFFFF' }}
        />
        <path
          d="M15.7675 13.6044L16.8465 14.4126C16.9792 14.512 17.1433 14.5581 17.3027 14.5408C17.4621 14.5236 17.6037 14.4443 17.6965 14.3205L21.8931 8.71791C22.0862 8.46006 22.0188 8.08327 21.7426 7.87633L17.7408 4.87876C17.4645 4.67182 17.084 4.71309 16.8908 4.97094L12.6942 10.5735C12.5571 10.7565 12.4798 11.0797 12.7778 11.1208L15.4672 9.57568C16.2734 9.09576 17.0574 10.4344 16.2509 10.9148C15.7656 11.2102 15.3196 11.5607 14.9215 11.9598C14.7282 12.8258 14.3436 13.6283 13.794 14.3126L13.0945 15.2464"
          stroke="#323232"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ fill: '#FDC033' }}
        />
      </EventIconWrapper>
    );
  }
}

export default YellowCardWithShirtNumber;
